import React, { useContext } from 'react';
import InstagramFillIcon from 'components/common/icons/fill/instagram-fill';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function InstagramDirectRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.instagramDirect;
  const instagramDirectSla = sla.instagramDirect;
  return (
    <FloorboardRow
      newItems={stats.currentNewMessages}
      activeItems={stats.currentOpenMessages}
      currentWait={stats.currentWait}
      sla={instagramDirectSla}
      activeLabel="Open Messages"
      newLabel="New Messages"
      waitLabel="Oldest Unanswered Message"
      icon={<InstagramFillIcon className="iconContainer" />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/instagram_direct_row.jsx